import configs from '../../configs'

export default {
    getters: {
        getLogos: (state) => state.logos,
        getTheme: (state) => state.theme,
    },
    state() {
        return {
            logos: {
                appBar: `${configs.theme.split('.')[0]}-app-bar.png`,
                home: `${configs.theme.split('.')[0]}-home.png`,
            },
            theme: configs.theme,
        }
    },
}
